// src/firebase/fcm.js
import {initializeApp} from 'firebase/app';
import {getMessaging, getToken, onMessage} from 'firebase/messaging';
import {REACT_APP_FIREBASE_CONFIG, REACT_APP_FIREBASE_VAPID_KEY} from "../env";

// TODO: Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: REACT_APP_FIREBASE_CONFIG,
  authDomain: "reposweb.firebaseapp.com",
  databaseURL: "https://reposweb.firebaseio.com",
  projectId: "reposweb",
  storageBucket: "reposweb.firebasestorage.app",
  messagingSenderId: "608419033879",
  appId: "1:608419033879:web:ff5b20969228f68d713d52"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

// Request permission and get token
export const requestFCMPermissionAndToken = async () => {
  try {
    const vapidKey = REACT_APP_FIREBASE_VAPID_KEY;
    // Request notification permission first
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('Notification permission not granted');
      return null;
    }
    // Wait for service worker ready and pass it to getToken
    const registration = await navigator.serviceWorker.ready;
    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration,
    });
    console.log('FCM Token:', token);
    return token;
  } catch (err) {
    console.error('FCM permission/token error:', err);
    return null;
  }
};

// Listen for foreground messages
export const onFCMMessage = (callback) => {
  onMessage(messaging, callback);
};

export { messaging };
